import { GraphQLError } from "graphql";

export const UNEXPECTED_GRAPHQL_ERROR_MESSAGE = "An unexpected error occurred.";

/** Returns safe display copy without modifying the GraphQL error. */
export default function getGraphQLErrorMessageForPresentation(
  error: GraphQLError,
) {
  if (error.extensions?.isUserFacing !== false) return error.message;

  const sentryId = error.extensions?.sentryId;

  return typeof sentryId === "string"
    ? `${UNEXPECTED_GRAPHQL_ERROR_MESSAGE} Our engineers have been notified. The error event is ${sentryId}.`
    : UNEXPECTED_GRAPHQL_ERROR_MESSAGE;
}
